export default "__VITE_ASSET__ZYtj2uJD__"